import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { downloadHandler } from "../common/UppHelper";

const DownloadMenu = ({ reportName, show }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="dropdown downloadIcon">
            <button
                className="download-button"
                type="button"
                id={`downloadMenu-${reportName}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                Download
                <i
                    className="bi bi-chevron-down"
                    aria-hidden="true"
                    style={{
                        marginLeft: "4px",
                        fontSize: "18px",
                        verticalAlign: "-2px",
                        WebkitTextStroke: "1px currentColor",
                    }}
                />
            </button>

            <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby={`downloadMenu-${reportName}`}
            >
                <li>
                    <button
                        type="button"
                        onClick={() => downloadHandler("pdf", reportName)}
                        className="dropdown-item"
                    >
                        Acrobat (PDF) file
                    </button>
                </li>

                <li>
                    <button
                        type="button"
                        onClick={() => downloadHandler("csv", reportName)}
                        className="dropdown-item"
                    >
                        CSV (comma delimited)
                    </button>
                </li>

                <li>
                    <button
                        type="button"
                        onClick={() => downloadHandler("xlsx", reportName)}
                        className="dropdown-item"
                    >
                        Excel
                    </button>
                </li>

                <li>
                    <button
                        type="button"
                        onClick={() => downloadHandler("xml", reportName)}
                        className="dropdown-item"
                    >
                        XML file with report data
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default DownloadMenu;